module.exports = __webpack_public_path__ + "static/media/portfolio-01.ddcf9d57.jpg";